export enum FilterCategoryEnum {
    ANY,
    STATUS,
    SHIPPER,
    DESTINATION,
    SERVICE,
    SHIPMENT_DATE,
    CARD,
    COUNTRY,
    ADDRESS_BOOK,
    BATCH
}
